var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"uk-flex uk-flex-center uk-flex-middle",staticStyle:{"min-height":"100%"}},[_c('div',{attrs:{"uk-spinner":"ratio: 2"}})])}]

export { render, staticRenderFns }